import React from 'react';
import {
    Create,
    SimpleForm,
    TextInput,
    required,
    SelectInput,
    ReferenceInput,
    DateInput,
} from 'react-admin';
import { useActiveStatus } from "../../defaults/defaults";
import { Grid } from "@mui/material";
import { ChatFieldBridge } from "../chat-bot/components/ChatFieldBridge";

export const AdminCompaniesHouseCreate = () => {
    const statuses = useActiveStatus();

    return (
        <Create>
            <SimpleForm>
                <Grid container spacing={ 2 }>
                    <Grid size={ 6 }>
                        <TextInput name="type" source="type" validate={[required()]} fullWidth />
                        <SelectInput
                            name="status"
                            source="status"
                            choices={ statuses }
                            optionValue="id"
                            validate={[required()]}
                        />
                        <DateInput name="incorporatedOn" source="incorporatedOn" fullWidth />
                    </Grid>
                    <Grid size={ 6 }>
                        <DateInput name="previousAccounts" source="previousAccounts" fullWidth />
                        <DateInput name="nextAccounts" source="nextAccounts" fullWidth />
                        <DateInput name="nextAccountsDue" source="nextAccountsDue" fullWidth />
                    </Grid>
                </Grid>
                <Grid container spacing={ 2 }>
                    <Grid size={ 6 }>
                        <DateInput name="previousConfirmationStatement" source="previousConfirmationStatement" fullWidth />
                        <DateInput name="nextConfirmationStatement" source="nextConfirmationStatement" fullWidth />
                        <DateInput name="nextConfirmationStatementDue" source="nextConfirmationStatementDue" fullWidth />
                    </Grid>
                    <Grid size={ 6 }>
                        <ReferenceInput
                            name="company"
                            label="company"
                            source="company"
                            reference="companies"
                        >
                            <SelectInput optionText="name"/>
                        </ReferenceInput>
                    </Grid>
                </Grid>
                {/* Offers this form to the assistant. Renders nothing, writes nothing by itself. */}
                <ChatFieldBridge />
            </SimpleForm>
        </Create>
    );
}